import { useEffect, useId, useRef, type ReactNode } from "react";
import { Knopf } from "./Knopf";
import s from "./ui.module.css";

interface Props {
  offen: boolean;
  titel: string;
  children: ReactNode;
  bestaetigen: string;
  gefaehrlich?: boolean;
  laeuft?: boolean;
  onBestaetigen: () => void;
  onAbbrechen: () => void;
}

/** Bestätigung vor Änderungen (Zugänge, Abmelden überall). Nutzt <dialog>: Fokus bleibt im Dialog, Escape bricht ab. */
export function Bestaetigung({ offen, titel, children, bestaetigen, gefaehrlich, laeuft, onBestaetigen, onAbbrechen }: Props) {
  const ref = useRef<HTMLDialogElement>(null);
  // Eigene Id je Dialog: Mehrere Bestätigungen auf einer Seite (Line-up: Act löschen, Floor entfernen) haben je ihren Namen
  const titelId = useId();
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (offen && !d.open) d.showModal();
    if (!offen && d.open) d.close();
  }, [offen]);
  return (
    <dialog ref={ref} className={s.dialog} onCancel={(e) => { e.preventDefault(); onAbbrechen(); }} aria-labelledby={titelId}>
      <h2 id={titelId}>{titel}</h2>
      <div>{children}</div>
      <div className={s.dialogKnoepfe}>
        <Knopf onClick={onAbbrechen} disabled={laeuft}>
          Abbrechen
        </Knopf>
        <Knopf art={gefaehrlich ? "gefahr" : "primaer"} ohnePunkt onClick={onBestaetigen} disabled={laeuft}>
          {laeuft ? "Einen Moment …" : bestaetigen}
        </Knopf>
      </div>
    </dialog>
  );
}
